'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { safeCall } from '@/app/utils/safeCall';
interface UseEscapeKeyProps {
  enabled?: boolean;
  onClose?: () => void;
}
export const useEscapeKey = t0 => {
  const $ = _c(4);
  const {
    enabled: t1,
    onClose
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  let t2;
  let t3;
  if ($[0] !== enabled || $[1] !== onClose) {
    t2 = () => {
      if (!enabled) {
        return;
      }
      const handleKeyDown = event => {
        if (event.key !== "Escape") {
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        safeCall(onClose);
      };
      window.addEventListener("keydown", handleKeyDown);
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    };
    t3 = [enabled, onClose];
    $[0] = enabled;
    $[1] = onClose;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
};